import EXIF from '@/util/core.EXIF';
import BinaryFile from '@/util/core.BinaryFile';

class FixDirect {
	init(file, callback) {
		// 创建一个reader
		let _this = this,
			reader = new FileReader();
		// 读取成功后的回调
		reader.onload = function(e) {
			let oExif = EXIF(new BinaryFile(e.target.result)) || {},
				$img = document.createElement('img');

			$img.onload = function() {
				_this.fixDirect().fix($img, oExif, callback);
			};

			$img.src = window.webkitURL.createObjectURL(file);
		};
		// 将图片将转成二进制格式
		reader.readAsBinaryString(file);
	}

	fixDirect() {
		let r = {},
			_this = this;
		r.fix = function(img, oExif, callback) {
			let n = img.naturalHeight,
				i = img.naturalWidth,
				c = 1024,
				o = document.createElement('canvas'),
				s = o.getContext('2d');
			oExif = oExif || {};

			if (n > c || i > c) {
				o.width = o.height = c;
			} else {
				o.width = i;
				o.height = n;
			}
			oExif.Orientation = oExif.Orientation || 1;
			r.detectSubSampling(img) && ((i /= 2), (n /= 2));
			let d, h;
			i > n
				? ((d = c), (h = Math.ceil(n / i * c)))
				: ((h = c), (d = Math.ceil(i / n * c)));

			let g = Math.max(o.width, o.height) / 2,
				l = document.createElement('canvas');
			if (n > c || i > c) {
				(l.width = g), (l.height = g);
			} else {
				l.width = i;
				l.height = n;
				d = i;
				h = n;
			}
			//l.width = g, l.height = g;
			let m = l.getContext('2d'),
				u = r.detect(img, n) || 1;
			s.save();
			r.transformCoordinate(o, d, h, oExif.Orientation);

			let isUC = navigator.userAgent.match(/UCBrowser[\/]?([\d.]+)/i);
			if (isUC && /(Android)/i.test(navigator.userAgent)) {
				s.drawImage(img, 0, 0, d, h);
			} else {
				for (
					let f = g * d / i, w = g * h / n / u, I = 0, b = 0;
					n > I;

				) {
					for (let x = 0, C = 0; i > x; )
						m.clearRect(0, 0, g, g),
							m.drawImage(img, -x, -I),
							s.drawImage(l, 0, 0, g, g, C, b, f, w),
							(x += g),
							(C += f);
					(I += g), (b += w);
				}
			}

			s.restore();
			oExif.Orientation = 1;
			img = document.createElement('img');
			img.onload = function() {
				oExif.PixelXDimension = img.width;
				oExif.PixelYDimension = img.height;
			};
			callback && callback(o.toDataURL('image/jpeg', 0.5)); //压缩图片
		};
		r.detect = function(img, a) {
			let e = document.createElement('canvas');
			e.width = 1;
			e.height = a;
			let r = e.getContext('2d');
			r.drawImage(img, 0, 0);
			let n = r.getImageData(0, 0, 1, a).data,
				c = a,
				o = a;
			for (let i = 0; o > i; ) {
				let s = n[4 * (o - 1) + 3];
				0 === s ? (c = o) : (i = o), (o = (c + i) >> 1);
			}
			let d = o / a;
			return 0 === d ? 1 : d;
		};
		r.detectSubSampling = function(img) {
			let a = img.naturalWidth,
				e = img.naturalHeight;
			if (a * e > 1048576) {
				let r = document.createElement('canvas');
				r.width = r.height = 1;
				let n = r.getContext('2d');
				return (
					n.drawImage(img, -a + 1, 0),
					0 === n.getImageData(0, 0, 1, 1).data[3]
				);
			}
			return !1;
		};
		// a: naturalWidth,e: naturalHeight
		r.transformCoordinate = function(img, a, e, Orientation) {
			console.log('Orientation:' + Orientation);
			switch (Orientation) {
				case 5:
				case 6:
				case 7:
				case 8:
					(img.width = e), (img.height = a);
					break;
				default:
					(img.width = a), (img.height = e);
			}
			let n = img.getContext('2d');
			switch (Orientation) {
				case 2:
					n.translate(a, 0), n.scale(-1, 1);
					break;
				case 3:
					n.translate(a, e), n.rotate(Math.PI);
					break;
				case 4:
					n.translate(0, e), n.scale(1, -1);
					break;
				case 5:
					n.rotate(0.5 * Math.PI), n.scale(1, -1);
					break;
				case 6:
					n.rotate(0.5 * Math.PI), n.translate(0, -e);
					break;
				case 7:
					n.rotate(0.5 * Math.PI), n.translate(a, -e), n.scale(-1, 1);
					break;
				case 8:
					n.rotate(-0.5 * Math.PI), n.translate(-a, 0);
			}
		};
		return r;
	}
}

export default FixDirect;



// WEBPACK FOOTER //
// ./src/module/basic/components/basic/headPortrait/FixDirect.js